/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react'
import { ReactReduxContext } from 'react-redux'
import intl from 'react-intl-universal'
import { Circulation, WebsitePayload } from '~/types'
import { Sections } from './Sections'
import { useEvidentlyFeatures } from '~/evidentlyFeatureFlags'
import { EVIDENTLY_FLAG } from '~/util/constants/keys'

interface WebsiteProps {
  isPrimary: boolean
  circulation: Circulation
}

export const Website: React.FC<WebsiteProps> = ({ isPrimary, circulation }) => {
  const [websiteName, setWebsiteName] = useState<string | undefined>(undefined)
  const { store } = React.useContext(ReactReduxContext)
  const featureFlag = useEvidentlyFeatures()

  const { websites } = store.getState()

  const showSectionName =
    featureFlag && featureFlag[EVIDENTLY_FLAG.SHOW_SECTION_NAME]

  const mainClass = isPrimary
    ? 'site-selector-v2--panel-website primary-website'
    : 'site-selector-v2--panel-website'

  const primarySection: any = circulation?.website_sections?.find(
    (websiteSection) => {
      return circulation?.website_primary_section?._id === websiteSection?._id
    }
  )

  const sections: any = circulation.website_sections?.filter(
    (websiteSection) => {
      return circulation.website_primary_section?._id !== websiteSection._id
    }
  )

  const mainDescriptionClass =
    sections && sections?.length > 0
      ? 'site-description'
      : 'site-description no-secondaries'

  React.useEffect(() => {
    const filteredWebsite: WebsitePayload | unknown = Object.values(
      websites
    ).find((website: WebsitePayload | unknown) => {
      return (website as WebsitePayload)._id === circulation.website_id
    })

    if (filteredWebsite) {
      setWebsiteName((filteredWebsite as WebsitePayload).display_name)
      return
    }

    setWebsiteName(circulation.website_id)
  }, [showSectionName, websites, circulation.website_id])

  return (
    <div
      className={mainClass}
      data-testid={`circulation-${circulation.website_id}`}
    >
      <div className="site-description">
        <label className="type-label">
          {isPrimary
            ? intl.get('SiteSelector.primaryWebsite')
            : intl.get('SiteSelector.website')}
        </label>
        <h4 className="site-title" data-testid="circulation-website-name">
          {websiteName}
        </h4>
      </div>
      <div className={mainDescriptionClass}>
        <label className="type-label">
          {intl.get('SiteSelector.primarySection')}
        </label>
        <p className="section">
          <Sections
            website={primarySection}
            showSectionName={showSectionName}
          />
        </p>
      </div>
      {sections && sections.length > 0 && (
        <div className="secondary-sections">
          {sections?.map((section) => (
            <p className="section" key={section._id}>
              <Sections website={section} showSectionName={showSectionName} />
            </p>
          ))}
        </div>
      )}
    </div>
  )
}
